import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "text-4xl font-medium" }

import { ref } from "vue";

import UsersTable from "../tables/UsersTable.vue";
import TitleHeader from "../TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";

import api from "@/api/api";
import { PaginationMeta, User } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersAdminDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const users = ref([] as User[]);
const meta = ref({} as PaginationMeta);

async function listUsers() {
  const response = await api.users.listUsers({
    page: 1,
    sort: "created_at",
    dir: "desc",
  });
  users.value = response.data.users;
  meta.value = response.meta;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listUsers())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("recent-users")), 1),
      _createVNode(UsersTable, {
        users: users.value.splice(0, 10),
        meta: meta.value,
        hide_pagination: true
      }, null, 8, ["users", "meta"]),
      _createVNode(RouterButton, {
        to: { name: 'Users' },
        type: "primary",
        class: "mt-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("view-all-users")), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})